import React from 'react';

type EmailIconProps = {
  className?: string;
  style?: React.CSSProperties;
};

export function EmailIcon({ className = '', style }: EmailIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      className={className}
      style={style}
    >
      <path
        d="M12.6 0H1.8C0.807816 0 0 0.807816 0 1.8V9.4C0 10.3922 0.807816 11.2 1.8 11.2H12.6C13.5922 11.2 14.4 10.3922 14.4 9.4V1.8C14.4 0.807816 13.5922 0 12.6 0ZM12.2635 1.2L7.59375 5.26641C7.37031 5.46172 7.03047 5.46172 6.80547 5.26641L2.13652 1.2H12.2635ZM12.6 10H1.8C1.46953 10 1.2 9.73047 1.2 9.4V1.975L6.01718 6.1711C6.35469 6.46485 6.77734 6.61172 7.2 6.61172C7.62266 6.61172 8.04531 6.46485 8.38203 6.1711L13.2 1.975V9.4C13.2 9.73047 12.9305 10 12.6 10Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default EmailIcon;
